module.exports = __webpack_public_path__ + "static/media/icn_hs_no_document.42605b68.svg";